export default __webpack_public_path__ + "static/maleDummy-96909af874923ba4d35883c318f494fb.png";